import Rate from './Rate';

export type { RateProps, RateCssVars } from './Rate';

export default Rate;
